import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import PrayerForm from '../Form';
import { fetchPrayer, updatePrayer } from '@resources/Prayer/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';

const Update = (props) => {
	const { fetchPrayer, prayer, updatePrayer, visible, onCancel } = props;
	const intl = useIntl();
	useEffect(() => {
		const fetchData = async () => {
			await fetchPrayer(visible);
		};
		visible && fetchData();
	}, [fetchPrayer, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updatePrayer(prayer._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.prayer.update',
							defaultMessage:
								'An existing Prayer entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[prayer]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.prayer',
					defaultMessage: 'Update Prayer',
				})}
			</Title>
			{!isEmpty(prayer) && (
				<PrayerForm data={prayer} onSubmit={handleSubmit} {...props} />
			)}
		</Modal>
	);
};

const mapStateToProps = ({ prayer }) => {
	return {
		prayer,
	};
};

export default connect(mapStateToProps, {
	fetchPrayer,
	updatePrayer,
})(Update);
